export default __webpack_public_path__ + "static/media/landscape.94e3c958.svg";